import { useMemo } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Column } from 'react-table';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PaginatedVehicleTable from '../../components/VehicleTable/PaginatedVehicleTable';
import { columnsData } from '../../components/MyStock/columnsData';
import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary';
import { toServerColumns } from 'src/vehicleList/columns';
import {
	availabilityOptions,
	stateOptions,
} from 'src/vehicleList/filterOptions';
import { usePaginatedVehicles } from 'src/vehicleList/usePaginatedVehicles';

const MyStockPage = () => {
	const [searchParams] = useSearchParams();
	const { t } = useTranslation();
	const navigate = useNavigate();

	const presetFilter = searchParams.get('prefilter');

	const { items, loading, error, tableProps } = usePaginatedVehicles({
		cacheKey: 'my-stock',
		baseParams: { scope: 'my-stock' },
	});

	const columns = useMemo(
		() => toServerColumns(columnsData) as Column<Object>[],
		[]
	);

	const filterOptions = useMemo(
		() => ({
			stato_corrente: stateOptions({}),
			stato_disp: availabilityOptions(),
		}),
		[]
	);

	const handleDoubleClick = (row: any) => {
		navigate(`/details/${row.original.id}`);
	};

	return (
		<Container fluid>
			<Row>
				<Col md={6} className="display-6">
					{t('my_stock')}
				</Col>
			</Row>

			<ErrorBoundary>
				<PaginatedVehicleTable
					{...tableProps}
					columns={columns}
					data={items}
					loading={loading}
					error={error}
					filterOptions={filterOptions}
					presetFilter={presetFilter}
					hiddenColumns={['id']}
					handleDoubleClick={handleDoubleClick}
				></PaginatedVehicleTable>
			</ErrorBoundary>
		</Container>
	);
};

export default MyStockPage;
